import { userReducer } from 'src/core/state/user';
import { signInEpic } from 'src/core/state/user';
import { persistUserEpic } from 'src/core/state/user';
import { hydrateEpic } from 'src/core/state/user';
import { refreshEpic } from 'src/core/state/user';
import { resetUserState } from 'src/core/state/user';
import { createAccountEpic } from 'src/features/user/feature/epics/register.epic';
import { clearApolloStoreOnAuthChange } from 'src/features/user/feature/epics/clearApolloStoreOnAuthChange.epic';

const NAME = 'user';

export function userRegister() {
    return {
        epics: [
            resetUserState,
            hydrateEpic,
            persistUserEpic,
            signInEpic,
            // // signOutOnPageView,
            refreshEpic,
            createAccountEpic,
            clearApolloStoreOnAuthChange,
        ],
        reducers: { [NAME]: userReducer },
        name: NAME,
    };
}
